export default __webpack_public_path__ + "static/media/pflegerat.dd31b871.png";